/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdMessageProps } from './type';

export const messageDefaultProps: TdMessageProps = { closeBtn: undefined, duration: 3000, icon: true, theme: 'info' };
